import {
  URLBuilder1hwx1b9569i61 as URLBuilder,
  Urlowwyg1lanrqp as Url,
} from '../../../../../ktor-ktor-http/io/ktor/http/URLUtils.mjs';
import {
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Companion_getInstanceudl2ftapa8hy as Companion_getInstance } from '../../../../../ktor-ktor-http/io/ktor/http/URLProtocol.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import {
  Close3tx65evcwi73t as Close,
  Binary3tlzyfojm51s4 as Binary,
  Text3e6ukp9joohql as Text,
} from '../../../../../ktor-ktor-websockets/io/ktor/websocket/Frame.nonJvm.mjs';
import {
  toString1pkumu07cwy4m as toString,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { decodeToString1x4faah2liw2p as decodeToString } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { readText30p9xkeoodw49 as readText } from '../../../../../ktor-ktor-websockets/io/ktor/websocket/FrameCommon.mjs';
import { Plugin_getInstance20jjnf84nf0zp as Plugin_getInstance } from '../../../../../ktor-ktor-client-core/io/ktor/client/plugins/websocket/WebSockets.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  ApolloNetworkException3denf70pfh242 as ApolloNetworkException,
  ApolloWebSocketClosedException26hvn543pf46i as ApolloWebSocketClosedException,
} from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import {
  coroutineScope2qhrb6lhutwsn as coroutineScope,
  CoroutineScopelux7s7zphw7e as CoroutineScope,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { headers24pki7ce1busg as headers } from '../../../../../ktor-ktor-client-core/io/ktor/client/request/HttpRequest.mjs';
import { url1qder21xodqzl as url } from '../../../../../ktor-ktor-client-core/io/ktor/client/request/buildersWithUrl.mjs';
import { webSocket30y01xcxbjfrw as webSocket } from '../../../../../ktor-ktor-client-core/io/ktor/client/plugins/websocket/builders.mjs';
import { CloseReason10cphaqpp3ct7 as CloseReason } from '../../../../../ktor-ktor-websockets/io/ktor/websocket/CloseReason.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Dispatchers_getInstance128lm494a5r5s as Dispatchers_getInstance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
import { SupervisorJobythnfxkr3jxc as SupervisorJob } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Supervisor.mjs';
import { Channel3r72atmcithql as Channel } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Channel.mjs';
import { HttpClient3584jcajl7sef as HttpClient } from '../../../../../ktor-ktor-client-core/io/ktor/client/HttpClient.web.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *open($this, url, headers, $completion) {
  // Inline function 'kotlin.apply' call
  var this_0 = URLBuilder(url);
  var tmp0_subject = url.protocol_1;
  var tmp;
  if (tmp0_subject.equals(Companion_getInstance().HTTPS_1)) {
    tmp = Companion_getInstance().WSS_1;
  } else if (tmp0_subject.equals(Companion_getInstance().HTTP_1)) {
    tmp = Companion_getInstance().WS_1;
  } else if (tmp0_subject.equals(Companion_getInstance().WS_1) || tmp0_subject.equals(Companion_getInstance().WSS_1)) {
    tmp = url.protocol_1;
  } else {
    throw UnsupportedOperationException().new_kotlin_UnsupportedOperationException_chzcdl_k$('SOCKS is not a supported protocol');
  }
  this_0.set_protocol_4rvp64_k$(tmp);
  var newUrl = this_0.build_1k0s4u_k$();
  launch($this.coroutineScope_1, VOID, VOID, KtorWebSocketEngine$open$slambda($this, newUrl, headers));
  return new (KtorWebSocketEngine$open$4())($this);
}
function *closeReasonOrNull($this, $receiver, $completion) {
  var tmp;
  try {
    tmp = yield* $receiver.get_closeReason_g1m41f_k$().await_4rdzbx_k$($completion);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var t = $p;
      if (t instanceof CancellationException()) {
        throw t;
      }
      tmp_0 = null;
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function *sendFrames($this, session, $completion) {
  while (true) {
    var frame = yield* $this.sendFrameChannel_1.receive_awoumx_k$($completion);
    yield* session.send_sburzs_k$(frame, $completion);
    if (frame instanceof Close()) {
      $this.receiveMessageChannel_1.close$default_kcbl7u_k$();
    }
  }
  return Unit_instance;
}
function *receiveFrames($this, incoming, $completion) {
  while (true) {
    var frame = yield* incoming.receive_awoumx_k$($completion);
    if (frame instanceof Text()) {
      $this.receiveMessageChannel_1.trySend_62dpg8_k$(readText(frame));
    } else {
      if (frame instanceof Binary()) {
        $this.receiveMessageChannel_1.trySend_62dpg8_k$(decodeToString(frame.data_1));
      } else {
        // Inline function 'kotlin.error' call
        var message = 'unknown frame type';
        throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
      }
    }
  }
  return Unit_instance;
}
function KtorWebSocketEngine$_init_$lambda_2axi3y($this$HttpClient) {
  $this$HttpClient.install$default_lc5jjj_k$(Plugin_getInstance());
  return Unit_instance;
}
function KtorWebSocketEngine$open$slambda$slambda$slambda$slambda(this$0, $this_webSocket) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* /*#__NOINLINE__*/sendFrames(this$0, $this_webSocket, $completion);
    return Unit_instance;
  }), 1);
}
function KtorWebSocketEngine$open$slambda$slambda$slambda(this$0, $this_webSocket) {
  return constructCallableReference(($this$coroutineScope, $completion) => orPromise($completion, function *($completion) {
    launch($this$coroutineScope, VOID, VOID, KtorWebSocketEngine$open$slambda$slambda$slambda$slambda(this$0, $this_webSocket));
    var tmp;
    try {
      tmp = yield* /*#__NOINLINE__*/receiveFrames(this$0, $this_webSocket.get_incoming_u9os29_k$(), $completion);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        var closeReason = yield* /*#__NOINLINE__*/closeReasonOrNull(this$0, $this_webSocket, $completion);
        var tmp_1;
        if (!(closeReason == null)) {
          tmp_1 = ApolloWebSocketClosedException().new_com_apollographql_apollo_exception_ApolloWebSocketClosedException_flboe8_k$(closeReason.code_1, closeReason.message_1, e);
        } else {
          tmp_1 = ApolloNetworkException().new_com_apollographql_apollo_exception_ApolloNetworkException_7j59h6_k$('Web socket communication error', e);
        }
        var apolloException = tmp_1;
        this$0.receiveMessageChannel_1.close_ukldxa_k$(apolloException);
        throw e;
      } else {
        throw $p;
      }
    }
    return Unit_instance;
  }), 1);
}
function KtorWebSocketEngine$open$slambda$slambda(this$0) {
  return constructCallableReference(($this$webSocket, $completion) => orPromise($completion, function *($completion) {
    yield* coroutineScope(KtorWebSocketEngine$open$slambda$slambda$slambda(this$0, $this$webSocket), $completion);
    return Unit_instance;
  }), 1);
}
function KtorWebSocketEngine$open$slambda(this$0, $newUrl, $headers) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    try {
      var tmp = ($this$webSocket) => {
        headers($this$webSocket, ($this$headers) => {
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s = $headers.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            $this$headers.append_rhug0a_k$(element.name_1, element.value_1);
          }
          return Unit_instance;
        });
        url($this$webSocket, $newUrl);
        return Unit_instance;
      };
      yield* webSocket(this$0.client_1, tmp, KtorWebSocketEngine$open$slambda$slambda(this$0), $completion);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        this$0.receiveMessageChannel_1.close_ukldxa_k$(ApolloNetworkException().new_com_apollographql_apollo_exception_ApolloNetworkException_7j59h6_k$('Web socket communication error', e));
      } else {
        throw $p;
      }
    }
    finally {
      this$0.receiveMessageChannel_1.close_ukldxa_k$(ApolloNetworkException().new_com_apollographql_apollo_exception_ApolloNetworkException_7j59h6_k$('Web socket communication error', null));
    }
    return Unit_instance;
  }), 1);
}
var KtorWebSocketEngine$open$4Class;
function KtorWebSocketEngine$open$4() {
  if (KtorWebSocketEngine$open$4Class === VOID) {
    class $ {
      constructor(this$0) {
        this.this$0__1 = this$0;
      }
      *receive_qir1pc_k$($completion) {
        return yield* this.this$0__1.receiveMessageChannel_1.receive_awoumx_k$($completion);
      }
      send_ut25s3_k$(data) {
        this.this$0__1.sendFrameChannel_1.trySend_62dpg8_k$(Binary().new_io_ktor_websocket_Frame_Binary_dw7hrz_k$(true, data.toByteArray_qczt2u_k$()));
      }
      send_oy6aea_k$(string) {
        this.this$0__1.sendFrameChannel_1.trySend_62dpg8_k$(Text().new_io_ktor_websocket_Frame_Text_j2nyd2_k$(string));
      }
      close_yn9xrc_k$() {
        this.this$0__1.sendFrameChannel_1.trySend_62dpg8_k$(Close().new_io_ktor_websocket_Frame_Close_zgly5v_k$(CloseReason().new_io_ktor_websocket_CloseReason_a5tz4j_k$(1000, '')));
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [0]);
    KtorWebSocketEngine$open$4Class = $;
  }
  return KtorWebSocketEngine$open$4Class;
}
var KtorWebSocketEngineClass;
function KtorWebSocketEngine() {
  if (KtorWebSocketEngineClass === VOID) {
    class $ {
      constructor(client) {
        return new.target.new_com_apollographql_ktor_ws_KtorWebSocketEngine_chaptc_k$(client);
      }
      static new_com_apollographql_ktor_ws_KtorWebSocketEngine_chaptc_k$(client) {
        var $this = createThis(this);
        $this.client_1 = client;
        $this.coroutineScope_1 = CoroutineScope(Dispatchers_getInstance().Default_1.plus_s13ygv_k$(SupervisorJob()));
        $this.receiveMessageChannel_1 = Channel(2147483647);
        $this.sendFrameChannel_1 = Channel(2147483647);
        return $this;
      }
      static new_com_apollographql_ktor_ws_KtorWebSocketEngine_815qyz_k$() {
        return this.new_com_apollographql_ktor_ws_KtorWebSocketEngine_chaptc_k$(HttpClient(KtorWebSocketEngine$_init_$lambda_2axi3y));
      }
      *open_uh9h1r_k$(url, headers, $completion) {
        return yield* /*#__NOINLINE__*/open(this, Url(url), headers, $completion);
      }
    }
    initMetadataForClass($, 'KtorWebSocketEngine', $.new_com_apollographql_ktor_ws_KtorWebSocketEngine_815qyz_k$, VOID, VOID, [2, 1]);
    KtorWebSocketEngineClass = $;
  }
  return KtorWebSocketEngineClass;
}
//region block: exports
export {
  KtorWebSocketEngine as KtorWebSocketEngine2cbfnq8i807su,
};
//endregion

//# sourceMappingURL=KtorWebSocketEngine.mjs.map
